import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { Accordion, Text } from '../index';
import { IconPartner, Link, Partner } from './styles';
import { baseURL } from '../../utils/defaults';

class AccordionPartner extends Component {
  render() {
    const { groups } = this.props;

    return groups.map(({ id, name, partners }) => (
      <Row key={id} className={'mb-3 mb-lg-4'}>
        <Col>
          <Accordion
            disabled={!partners.length}
            id={id.toString()}
            summary={<Text labelAcordeon text={name} />}
            details={
              <>
                {partners.map(({ name, describe, link, file }, i) => (
                  <Partner key={i}>
                    <IconPartner img={`${baseURL()}/api/file/${file.id}/${file.slug}`}>
                      <div />
                    </IconPartner>
                    <Text paragraph3 pre text={`<strong>${name}</strong> <br/>${describe}`} />
                    <Link>
                      Visite:{' '}
                      <a
                        style={{ overflowWrap: 'break-word' }}
                        href={link}
                        target="_blank"
                        rel="noreferrer">
                        {link.split('://').pop()}
                      </a>
                    </Link>
                  </Partner>
                ))}
              </>
            }
          />
        </Col>
      </Row>
    ));
  }
}

AccordionPartner.propTypes = {
  groups: PropTypes.array,
};

export default AccordionPartner;
